// The app's own reloads that must not raise the browser's "Leave site?" prompt.
//
// Switching view-as writes the new role to sessionStorage, which every request
// reads, and then reloads. Cancel on the prompt kept the page but not the admin:
// the screen still showed the old role, with no banner, while every save came
// back VIEW_AS_READ_ONLY — and the only way out was the reload it had just
// refused. A reload that has already changed state has to go through.
//
// There is no resume: the reload that follows starts this module over.
let suspended = false;

export function suspendUnloadGuard() { suspended = true; }
export function unloadGuardSuspended() { return suspended; }
